import axios from 'axios';
var NotificationsApi = /** @class */ (function () {
    function NotificationsApi(token, apiUrl) {
        this.token = token;
        this.axios = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: token,
            },
        });
    }
    NotificationsApi.prototype.getUrl = function (groupId) {
        return "/v1/groups/" + groupId + "/notification-settings";
    };
    NotificationsApi.prototype.getNotificationSettings = function (groupId, channel) {
        return this.axios.get(this.getUrl(groupId) + "?channel=" + channel);
    };
    NotificationsApi.prototype.updateNotificationSettings = function (groupId, req) {
        return this.axios.post("" + this.getUrl(groupId), req);
    };
    return NotificationsApi;
}());
export { NotificationsApi };
//# sourceMappingURL=NotificationsApi.js.map